import { render, staticRenderFns } from "./CadastroMedico.vue?vue&type=template&id=a1008cc6&scoped=true"
import script from "./CadastroMedico.vue?vue&type=script&lang=ts"
export * from "./CadastroMedico.vue?vue&type=script&lang=ts"
import style0 from "./CadastroMedico.vue?vue&type=style&index=0&id=a1008cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1008cc6",
  null
  
)

export default component.exports